import { secureGet } from '../utils/HttpUtils';

export const getClients = async ({ 
  page = 1, 
  size = 10, 
  q = '', 
  referrer = '', 
  sortField = '', 
  sortDirection = '',
  commercialId = '',
  producerId = '',
  status = ''
}) => {
  let url = `/v1/private/clients?page=${page}&size=${size}`;
  if (q) url += `&q=${encodeURIComponent(q)}`;
  if (referrer) url += `&referrer=${encodeURIComponent(referrer)}`;
  if (sortField) url += `&sortField=${encodeURIComponent(sortField)}`;
  if (sortDirection) url += `&sortDirection=${encodeURIComponent(sortDirection)}`;
  if (commercialId) url += `&commercialId=${encodeURIComponent(commercialId)}`;
  if (producerId) url += `&producerId=${encodeURIComponent(producerId)}`;
  if (status) url += `&status=${encodeURIComponent(status)}`;
  return secureGet(url);
};

export const getClientDetail = async (cuit: string) => {
  return secureGet(`/v1/private/clients/${cuit}`);
};
